import { API_BASE_API_SSO_URL } from '../../urls';

export const API_SEARCH_USERS_URL = `${API_BASE_API_SSO_URL}/users/share/search`;
